import React, {useState} from 'react';

import {Popup} from 'client/common/components/lego';

interface UsePopupProps {
    initialVisible?: boolean;
    className?: string;
}

export function usePopup(ref: any, {initialVisible}: UsePopupProps = {}) {
    const [isVisible, setIsVisible] = useState(initialVisible || false);

    const close = () => {
        setIsVisible(false);
    };

    const open = () => {
        setIsVisible(true);
    };

    const toggle = () => {
        setIsVisible(!isVisible);
    };

    const WrapperPopup = ({children, ...rest}: any) => (
        <Popup
            anchor={ref}
            keepMounted={false}
            target='anchor'
            view='default'
            visible={isVisible}
            zIndex={1010}
            onClose={close}
            {...rest}
        >
            {children}
        </Popup>
    );

    return {
        popup: WrapperPopup,
        toggle,
        close,
        open
    };
}
